import React from 'react';
import { FeatureDecisionContext } from "./FeatureDecisionProvider";
export function useFeatureDecision() {
  //@ts-expect-error ToDo: fix this
  var decisionContext = React.useContext(FeatureDecisionContext);
  //@ts-expect-error ToDo: fix this
  return [decisionContext === null || decisionContext === void 0 ? void 0 : decisionContext.engine, decisionContext === null || decisionContext === void 0 ? void 0 : decisionContext.isReady];
}